export default (function (value) {
  return Array.isArray(value);
});


//////////////////
// WEBPACK FOOTER
// ./~/redux-blueprint/~/redux-actions/es/utils/isArray.js
// module id = 1450
// module chunks = 1